import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';

import { LanguageDefaults } from '../../../../voice-response-command/vrc-audio-metadata/language-defaults';
import { MessageTemplateContextObj } from '../message-template-context-obj';

export const makeContextForDate = (
  date: moment.Moment,
  timezone: string,
  language: LanguageDefaults,
): MessageTemplateContextObj => {
  const localizedDate = cloneDeep(date).tz(timezone).locale(language.getShortCode());
  const result = {} as MessageTemplateContextObj;
  result.calendar = localizedDate.calendar();
  result.fromNow = localizedDate.fromNow();
  for (const key of [
    'M',
    'Mo',
    'MM',
    'MMM',
    'MMMM',
    'Q',
    'Qo',
    'D',
    'Do',
    'DD',
    'DDD',
    'DDDo',
    'DDDD',
    'd',
    'do',
    'dd',
    'ddd',
    'dddd',
    'e',
    'E',
    'YY',
    'YYYY',
    'A',
    'a',
    'H',
    'HH',
    'h',
    'hh',
    'k',
    'kk',
    'm',
    'mm',
    'z',
    'zz',
    'Z',
    'ZZ',
    'X',
    'LT',
    'LTS',
    'L',
    'l',
    'LL',
    'll',
    'LLL',
    'lll',
    'LLLL',
    'llll',
  ]) {
    result[key] = localizedDate.format(key);
  }

  return result;
};
